import green from '@material-ui/core/colors/green'

export default ({ breakpoints, palette, spacing }) => ({
  appTitle: {
    color: palette.primary.contrastText,
    cursor: 'pointer',
    fontFamily: "'Monoton', cursive",
    fontSize: 42
  },
  appTitleWrapper: {
    [breakpoints.down('xs')]: {
      position: 'relative'
    },
    left: 0,
    paddingLeft: spacing.unit * 2,
    paddingTop: spacing.unit,
    position: 'fixed',
    top: 0,
    width: '100%'
  },
  card: {
    minWidth: 350
  },
  submit: {
    display: 'none'
  },
  title: {
    color: palette.primary.contrastText,
    marginBottom: spacing.unit * 2
  },
  welcome: {
    color: palette.primary.contrastText,
    marginBottom: spacing.unit,
    marginTop: spacing.unit,
    maxWidth: 600
  },
  welcomeIcon: {
    backgroundColor: green[500],
    borderRadius: '50%',
    color: '#fff',
    fontSize: 200
  },
  wrapper: {
    alignItems: 'center',
    background: palette.primary.dark,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '100%',
    position: 'absolute',
    // tslint:disable-next-line:object-literal-sort-keys
    'overflow-x': 'hidden',
    'overflow-y': 'auto',
    width: '100%'
  }
})



// WEBPACK FOOTER //
// ./src/views/Registration/styles.js